import angular from 'angular'

import styles from './styles/styles'

import scrollOnClick from './scrollOnClick.directive'

const name = 'elementsResources'

angular.module(name, [])
  .constant('styles', styles)
  .directive('scrollOnClick', scrollOnClick)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/resources/resource.module.js